import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import {
  DeleteParams,
  ExercisesCreateInterface,
  ExercisesInterface,
  GetExercisesIdInterface,
} from "../types/types";
import { exercises } from "../products/exercises";
export function useCreateExercises(): UseMutationResult<
  any,
  unknown,
  ExercisesCreateInterface,
  unknown
> {
  return useMutation({
    mutationFn: (body: ExercisesCreateInterface) =>
      exercises.createExercises(body),
  });
}
export function useUpdateExercises(
  id: number
): UseMutationResult<any, unknown, ExercisesCreateInterface, unknown> {
  return useMutation({
    mutationFn: (body: ExercisesCreateInterface) =>
      exercises.UpdateExercises(body, id),
  });
}
export function useDeleteExercises(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => exercises.deleteExercises(body.id),
  });
}
export function useGetExercises(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<ExercisesInterface>({
      queryKey: ["getExercises"],
      queryFn: () => exercises.GetExercises(option),
    });

  return {
    exercisesData: data,
    exercisesLoading: isLoading,
    error,
    status,
    isSuccess,
    exercisesRefetch: refetch,
  };
}
export function useGetExercisesId(id?: number) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<GetExercisesIdInterface>({
      queryKey: ["getExercisesById", id],
      queryFn: () => exercises.GetExercisesById(Number(id)),
      enabled: !!id,
    });

  return {
    exerciseData: data,
    exerciseLoading: isLoading,
    error,
    status,
    isSuccess,
    exerciseRefetch: refetch,
  };
}
